/// <reference path="../svg.d.ts" />
import React from 'react';
import { Check as LucideCheck } from 'lucide-react';
import { getIconProps, IconProps } from '../utils';

export const CheckIcon: React.FC<IconProps> = props => {
  const iconProps = getIconProps(props);
  return <LucideCheck {...iconProps} />;
};

